<p>
  {{ weatherAlert }}
</p>
